module.exports = __webpack_public_path__ + "img/centro-medico-talar.d586a9ee.png";